import { Injectable } from '@angular/core';
import { ActionService } from './action.service';
import { ActionEnum } from '../../../enum/action.enum';
import { Observable, throwError } from 'rxjs';
import { SubmitResult } from '../../../models/submit-result';
import { filter, map, tap } from 'rxjs/operators';
import { ActionStatusEnum } from '../../../enum/action-status.enum';
import { VoidResult } from '../../../models/void-result';
import { LocaleService } from './locale.service';
import { shipmentNumber } from '../../../utils/shipment-number';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class SubmissionService {

    constructor(private actionService: ActionService, private snackbar: MatSnackBar, private localeService: LocaleService) {
    }

    submitShipmentMulti(ids: string[]): void {
        this.actionService.sync(ActionEnum.SHIPMENT_SUBMIT_MULTI, ids).subscribe();
    }

    submitShipment(shipmentId: string): void {
        this.actionService.sync(ActionEnum.SHIPMENT_SUBMIT, [ shipmentId ]).subscribe();
    }

    submitQuote(shipmentId, quoteId: string): Observable<SubmitResult> {
        return this.actionService.sync(ActionEnum.SHIPMENT_SUBMIT, [ shipmentId ], { quoteId }).pipe(
            filter((action) => action.status === ActionStatusEnum.COMPLETED || action.status === ActionStatusEnum.ERROR),
            map((action) => {
                if (action.status === ActionStatusEnum.ERROR) {
                    return {
                        result: ActionStatusEnum.ERROR,
                        messages: action.errors,
                        documents: [],
                        trackingNumber: null,
                        packageTrackingNumbers: {},
                        shipmentId,
                        shipmentNumber: null
                    };
                } else {
                    return action.output[shipmentId] as SubmitResult;
                }
            })
        );
    }

    voidMulti(ids: string[]): Observable<VoidResult> {
        return this.actionService.sync(ActionEnum.SHIPMENT_VOID_MULTI, ids).pipe(
            tap((action) => {
                if (action.status === ActionStatusEnum.COMPLETED) {
                    ids.forEach((id) => {
                        const output: VoidResult = (action.output[id] || action.output);
                        if (output.result === 'REJECTED') {
                            for (const message of output.messages) {
                                this.snackbar.open(shipmentNumber(id) + ' ' + this.localeService.renderServerMessage(message));
                            }
                        }
                    });
                }
            }),
            filter((action) => action.status === ActionStatusEnum.COMPLETED || action.status === ActionStatusEnum.ERROR),
            map((action) => ({ shipmentIds: action.entityIds, result: action.status, messages: [] }))
        );
    }

    void(shipmentId: string): Observable<VoidResult> {
        return this.actionService.sync(ActionEnum.SHIPMENT_VOID, [ shipmentId ]).pipe(
            filter((action) => action.status === ActionStatusEnum.COMPLETED || action.status === ActionStatusEnum.ERROR),
            map((action) => ({ shipmentIds: action.entityIds, ...action.output[shipmentId] } as VoidResult))
        );
    }

}
